/** @jsx jsx */

import PropTypes from "prop-types"
import { jsx, Flex, Button, Heading } from "theme-ui"
import { Fragment } from "react"

import { TransformedCrystallizeProductPropTypes } from "../../utils/propTypes"
import { Crystallize } from "../../enums/Crystallize"
import { JournazineDetails } from "../JournazineDetails"
import { ProductControls } from "./ProductControls"
import { Divider } from "../Divider"
import { DividerType } from "../../hooks/divider"
import { formatPrice } from "../../utils/displayUtils"
import { Paragraph } from "theme-ui"

const extractJournazineDetails = product => {
  return {
    cover_image: product.defaultVariant.images[0],
    issue_number: product.components["issue-number"].content.text,
    issue_title: product.components["issue-title"].content,
    issue_description: product.components["description"].content,
  }
}

const ProductCtaButtons = ({ onCheckout, containerStyles }) => (
  <Flex
    sx={{
      justifyContent: ["center", null, null, "flex-start"],
      my: 3,
      ...containerStyles,
    }}
  >
    <Button
      variant="olive"
      onClick={onCheckout}
      sx={{ ml: 0, px: [3, 3, 4, 5], fontSize: [0, 0, 2, 3] }}
    >
      Checkout Now
    </Button>
  </Flex>
)
ProductCtaButtons.propTypes = {
  onCheckout: PropTypes.func,
  containerStyles: PropTypes.object,
}

export const ProductDetails = ({
  product,
  selectionState,
  updateSelectionState,
  onCheckout,
}) => {
  const productShape = product.shape.name

  if (productShape === Crystallize.ProductShape.JOURNAZINE) {
    return (
      <JournazineDetails
        {...extractJournazineDetails(product)}
        otherChildren={
          <Fragment>
            <ProductControls
              product={product}
              labels={{ quantity: "No. of Print Copies" }}
              selectionState={selectionState}
              updateSelectionState={updateSelectionState}
            />
            <Flex
              sx={{
                flexDirection: "column",
                textAlign: ["center", "center", "center", "left"],
                my: 5,
              }}
            >
              <Heading
                as="h3"
                variant="subheading"
                sx={{ color: "oliveGreen" }}
              >
                Total
              </Heading>
              <Heading
                as="h2"
                variant="headingOlive"
                sx={{ fontWeight: "body" }}
              >
                {formatPrice(selectionState.cost)}
              </Heading>
              <Paragraph variant="fineprint" sx={{ color: "oliveGreen" }}>
                * Shipping will be calculated at checkout
              </Paragraph>
            </Flex>
            <Divider type={DividerType.DEFAULT_OLIVE} />
            <ProductCtaButtons
              onCheckout={onCheckout}
              containerStyles={{ my: 5 }}
            />
          </Fragment>
        }
      />
    )
  }

  return null
}
ProductDetails.propTypes = {
  product: PropTypes.shape(TransformedCrystallizeProductPropTypes),
  selectionState: PropTypes.shape({
    cost: PropTypes.number,
    variantSku: PropTypes.string,
    quantity: PropTypes.number,
  }),
  updateSelectionState: PropTypes.func,
  onCheckout: PropTypes.func,
}
